import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useNavBlocker = (enabled = true, shouldBlock: boolean) => {
  const navigate = useNavigate();
  const location = useLocation();
  const prevLocation = useRef(location);
  const [showPrompt, setShowPrompt] = useState(false);
  const [nextLocation, setNextLocation] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    if (!shouldBlock) {
      prevLocation.current = location;
      return;
    }
  
    const wasInPreliquidacion = prevLocation.current.pathname.startsWith("/cobranzas/preliquidacion");
    const goingOutOfPreliquidacion = !location.pathname.startsWith("/cobranzas/preliquidacion");
  
    if (wasInPreliquidacion && goingOutOfPreliquidacion) {
      // Al salir de preliquidación, mostramos modal
      setNextLocation(location.pathname);
      setShowPrompt(true);
  
      // revertir navegación
      navigate(prevLocation.current.pathname, { replace: true });
    } else {
      // actualizar prevLocation si solo navegamos dentro de preliquidación
      prevLocation.current = location;
    }
  }, [location, navigate, enabled, shouldBlock]);
  const confirmNavigation = () => {
    if (nextLocation) {
      prevLocation.current = { ...location };
      navigate(nextLocation);
    }
    setShowPrompt(false);
    setNextLocation(null);
  };

  const cancelNavigation = () => {
    setShowPrompt(false);
    setNextLocation(null);
  };

  return { showPrompt, confirmNavigation, cancelNavigation };
};
